import { Component, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ConfirmationModalComponent } from '@premotec/pmt-bootstrap';
import { BsModalService } from 'ngx-bootstrap/modal';

import { FileDownloadHelper } from '../../../../../../shared/helpers/file-download.helper';
import { FileDownloadModel } from '../../../../../../shared/models/file-download.model';
import { SharedToasterService } from '../../../../../../shared/services/shared-toaster.service';
import { AssignmentsParticipantService } from '../../../services/assignments-participants.service';

@Component({
    selector: 'app-assignment-participant-registration-details-export',
    templateUrl: './assignment-participant-registration-details-export.component.html',
    styleUrl: './assignment-participant-registration-details-export.component.scss'
})
export class AssignmentParticipantRegistrationDetailsExportComponent {
    @Input() assignmentId!: number;

    protected isLoading: boolean = false;

    constructor(
        private bsModalService: BsModalService,
        private translocoService: TranslocoService,
        private assignmentsParticipantService: AssignmentsParticipantService,
        private sharedToasterService: SharedToasterService
    ) { }

    protected openModal(): void {
        let bsModalRef = this.bsModalService.show(ConfirmationModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                title: this.translocoService.translate('assignments.participants.registrationDetails.download'),
                body: this.translocoService.translate('assignments.participants.registrationDetails.downloadQuestion'),
                iconCode: 'fa-solid fa-download'
            }
        });

        bsModalRef.content?.confirmed.subscribe({
            next: () => {
                this.bsModalService.hide();
                this.downloadRegistrationDetails();
            }
        });
    }

    private downloadRegistrationDetails() {
        this.isLoading = true;
        this.assignmentsParticipantService.downloadAssignmentParticipanstRegistrationDetails(this.assignmentId).subscribe({
            next: (file: FileDownloadModel) => {
                this.isLoading = false;
                FileDownloadHelper.downloadFile(file.name, file.contentType, file.data);
                this.sharedToasterService.showGeneralDownloadingSuccess();
            },
            error: () => {
                this.isLoading = false;
                this.sharedToasterService.showGeneralDownloadingError();
            }
        });
    }
}
